import { setGetOperatorsAction } from '../action';
import { getOperators } from '../api/getOperators';

export const setGetOperators = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getOperators(params);
            dispatch(setGetOperatorsAction({
                data: data.data,
                currentPage: data?.pagination?.currentPage,
                currentRowsPerpage: data?.pagination?.currentRowsPerPage,
                total: data?.pagination?.total,
                totalPage: data?.pagination?.totalPage
            }))

            if (callback) {
                callback();
            }
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}